import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Avatar,
  Chip,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  Popover,
  ButtonGroup,
  Tooltip,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Assignment,
  Group,
  Close,
  ArrowForwardIos,
  CheckCircle,
  Block,
  Receipt,
  DateRange,
  DevicesOther,
  CreditCard,
  Edit,
  AttachMoney,
  AvTimer
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/styles";

import MUIDataTable from "mui-datatables";

import { Skeleton } from "@material-ui/lab";
import Format from "date-fns/format";
import { DatePicker } from "@material-ui/pickers";
import { TableFooter, TableCell, TableRow } from "@material-ui/core";

import { useSnackbar } from "notistack";

import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
} from "../../../../../../utils/web_config";
//import { useTransactionTypes } from "../../../../hooks/use_hooks";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function StockStatusTwo(props) {
  const classes = useStyles();
  const history = useHistory();

  const [accountData, setAccountData] = useState({});
  const [transactions, setTransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading stock items...",
    loading: false,
    toggling: false,
    open:false,
    data:[],
  });

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [from, setFrom] = useState({
    value: new Date(),
    error: "",
  });
  const [to, setTo] = useState({
    value: new Date(),
    error: "",
  });

  const [range, setRange] = useState({ index: 0, acnhor: null });

  const [customers,setCustomers]=useState([]);

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getTransactions(accountData.token, from.value, to.value);
    get_customer(accountData.token);
  }, []);

  const get_customer=(token)=>{

    const customersInstance = axios.create(new AdminService().getHeaders(token));

    setTransactions({ ...transactions, loading: true });

    console.log("getting all customers  .....");

    customersInstance
      .get(new ReportingService().GET_ALL_CUSTOMERS)
      .then(function (response) {
        console.log("response",response.data.data.content);
        // setTransactions({ ...transactions, loading: false });

        const d = response.data;

        setCustomers(d.data.content);

      })
      .catch(function (error) {

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  }

 
  const transactionsColums = [
    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "category_name",
      label: "Category Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "item_type",
      label: "Item Type",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "out_of_stock_flag",
      label: "Out of stock flag",
      options: {
        filter: false,
        sort: false,
        //   customBodyRender: (value) => (
        //     <span>{new Validator().formatMoney(value)}</span>
        //   ),
      },
    },
    {
      name: "supplier_name",
      label: "Supplier Name",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "serial_number",
      label: "Serial Number",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "uid",
      label: "UID",
      options: {
        filter: false,
        sort: true,
      },
    },
   
    {
      name: "model",
      label: "Model",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "tag_number",
      label: "Tag Number",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "gps_coordinates",
      label: "Coordinates",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "province",
      label: "Province",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "district",
      label: "District",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "unit_price",
      label: "Price",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "damaged",
      label: "Damaged",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: true,
      },
    }
    
  ];

  const transactionsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search here...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    // onCellClick: (cellData, cellMeta) => {
    //   var tr = transactions.data[cellMeta.dataIndex];
    //   history.push("/centrika/agents/details/viewTransaction", tr);
    // },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transactions.status,
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomItemToolbar
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
        getItem={getItem}
        setItemId={setItemId}
        setDialogSale={setDialogSale}
        setDialogRent={setDialogRent}
      />
    ),
    
    // customTableBodyFooterRender: function (opts) {
 

    //   let sumPrev = opts.data
    //     ?.map((item) => item.data[4])
    //     .reduce((prev, curr) => prev + curr, 0);

    //   let sumPrevDam = opts.data
    //     ?.map((item) => item.data[5])
    //     .reduce((prev, curr) => prev + curr, 0);

    //   let sumQIn = opts.data
    //     ?.map((item) => item.data[6])
    //     .reduce((prev, curr) => prev + curr, 0);
    //   let sumQOut = opts.data
    //     ?.map((item) => item.data[7])
    //     .reduce((prev, curr) => prev + curr, 0);

    //   let sumDamQIn = opts.data
    //     ?.map((item) => item.data[8])
    //     .reduce((prev, curr) => prev + curr, 0);
    //   let sumDamQOut = opts.data
    //     ?.map((item) => item.data[9])
    //     .reduce((prev, curr) => prev + curr, 0);

    //   let sumCurrQ = opts.data
    //     ?.map((item) => item.data[10])
    //     .reduce((prev, curr) => prev + curr, 0);

    //   let sumCurrDamQ = opts.data
    //     ?.map((item) => item.data[11])
    //     .reduce((prev, curr) => prev + curr, 0);

    //   sumPrev = Math.round(sumPrev);
    //   sumPrevDam = Math.round(sumPrevDam);
    //   sumQIn = Math.round(sumQIn);
    //   sumQOut = Math.round(sumQOut);
    //   sumDamQIn = Math.round(sumDamQIn);
    //   sumDamQOut = Math.round(sumDamQOut);
    //   sumCurrQ = Math.round(sumCurrQ);
    //   sumCurrDamQ = Math.round(sumCurrDamQ);

    //   return (
    //     <TableFooter className={classes.stickyFooter}>
    //       <TableRow>
    //         {opts.selectableRows !== "none" ? (
    //           <TableCell className={classes.stickyFooter} />
    //         ) : null}
    //         {opts.columns.map((col, index) => {
    //           if (col.display === "true") {
    //             if (col.name === "previous_quantity") {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter}>
    //                   Total: <b>{sumPrev}</b>
    //                 </TableCell>
    //               );
    //             } else if (col.name === "previous_damaged_quantity") {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter}>
    //                   Total: <b>{sumPrevDam}</b>
    //                 </TableCell>
    //               );
    //             } else if (col.name === "quantity_in") {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter}>
    //                   Total: <b>{sumQIn}</b>
    //                 </TableCell>
    //               );
    //             } else if (col.name === "quantity_out") {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter}>
    //                   Total: <b>{sumQOut}</b>
    //                 </TableCell>
    //               );
    //             } else if (col.name === "damaged_quantity_in") {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter}>
    //                   Total: <b>{sumDamQIn}</b>
    //                 </TableCell>
    //               );
    //             } else if (col.name === "damaged_quantity_out") {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter}>
    //                   Total: <b>{sumDamQOut}</b>
    //                 </TableCell>
    //               );
    //             } else if (col.name === "current_quantity") {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter}>
    //                   Total: <b>{sumCurrQ}</b>
    //                 </TableCell>
    //               );
    //             } else if (col.name === "current_damaged_quantity") {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter}>
    //                   Total: <b>{sumCurrDamQ}</b>
    //                 </TableCell>
    //               );
    //             } else {
    //               return (
    //                 <TableCell key={index} className={classes.stickyFooter} />
    //               );
    //             }
    //           }
    //           return null;
    //         })}
    //       </TableRow>
    //     </TableFooter>
    //   );
    // },
  };

  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  ///////////////////////////////////

  ///////////////////////////////////

  const getTransactions = (token, fromDate, toDate) => {
    const createInstance = axios.create(new AdminService().getHeaders(token));

    setTransactions({ ...transactions, loading: true });

    console.log("getting all items in the stock .....");

   

    createInstance
      .get(new ReportingService().GET_ALL_ITEMS)
      .then(function (response) {
        console.log("response",response.data.data.content);
        // setTransactions({ ...transactions, loading: false });

        const d = response.data;

        if (response.data.data.content.length == 0) {
          setTransactions({
            ...transactions,
            data: d.data.content,
            status: "There are no items available",
          });
        } else {

          var objs=d.data.content;
          objs.map((o,i)=>{
            o['item_type']=o.item_category.item_type;
            o['category_name']=o.item_category.name;
            o['out_of_stock_flag']=o.item_category.out_of_stock_flag;
            o['supplier_name']=o.supply.supplier_name;
            o['damaged']=""+o['damaged'];

          });

          console.log("objs",objs);

          var groups = new Validator().groupArrayOfObjects(objs, "item_type");
          var keys = Object.keys(groups);

          setTransactions({
            ...transactions,
            data: objs,
            allData: objs,
            groups:groups,
            keys: keys,
            loading: false
          });


        }
      })
      .catch(function (error) {
        setTransactions({ ...transactions, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setTransactions({ ...transactions, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };


  ////// update item ///////



  const [item,setItem]=useState({});
  const [cell,setCell]=useState({value:"",error:""});
  const [damaged,setDamaged]=useState({value:"",error:""});
  const [district,setDistrict]=useState({value:"",error:""});
  const [gpsCoordinates,setGpsCoordinates]=useState({value:"",error:""});
  const [model,setModel]=useState({value:"",error:""});
  const [province,setProvince]=useState({value:"",error:""})
  const [sector,setSector]=useState({value:"",error:""});
  const [serialNumber,setSerialNumber]=useState({value:"",error:""});
  const [streetHouse,setStreetHouse]=useState({value:"",error:""});
  const [tagNumber,setTagNumber]=useState({value:"",error:""});
  const [uid,setUid]=useState({value:"",error:""});
  const [unitPrice,setUnitPrice]=useState({value:"",error:""});
  const [village,setVillage]=useState({value:"",error:""});
  const [id,setId]=useState({value:0,error:""});
  


  const getItem=(id)=>{
    var o=transactions.data.filter((o)=>o.id==id)[0];
    
    setItem({});
    setId(id);
    setCell({value:o.cell,error:""});
    setDamaged({value:o.damaged,error:""});
    setDistrict({value:o.district,error:""});
    setGpsCoordinates({value:o.gps_coordinates,error:""});
    setModel({value:o.model,error:""});
    setProvince({value:o.province,error:""})
    setSector({value:o.sector,error:""});
    setSerialNumber({value:o.serial_number,error:""});
    setStreetHouse({value:o.street_house,error:""});
    setTagNumber({value:o.tag_number,error:""});
    setUid({value:o.uid,error:""});
    setUnitPrice({value:o.unit_price,error:""});
    setVillage({value:o.village,error:""});

    setTransactions({...transactions,open:true});

  }

  const updateItem=()=>{
    if(cell.value==""){
      setCell({value:"",error:"Enter cell"});
    }else if(damaged.value==""){
      setDamaged({value:"",error:"Select damage status"});
    }else if(district.value==""){
      setDistrict({value:"",error:"Enter district"});
    }else if(sector.value==""){
      setSector({value:"",error:"Enter sector"});
    }else if(gpsCoordinates.value==""){
      setGpsCoordinates({value:"",error:"Enter GPS coordinates"});
    }else if(model.value==""){
      setModel({value:"",error:"Enter model"});
    }else if(province.value==""){
      setProvince({value:"",error:"Enter province"});
    }else if(serialNumber.value==""){
      setSerialNumber({value:"",error:"Enter serial number"});
    }else if(streetHouse.value==""){
      setStreetHouse({value:"",error:"Enter street house"});
    }else if(tagNumber.value==""){
      setTagNumber({value:"",error:"Enter tag number"});
    }else if(uid.value==""){
      setUid({value:"",error:"Enter UID"});
    }else if(unitPrice.value==0){
      setUnitPrice({value:"",error:"Enter price"});
    }else if(village.value==""){
      setVillage({value:"",error:"Enter village"});
    }else{

    const updateInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setTransactions({...transactions,loading:true});

    let data={
      cell: cell.value,
      damaged: damaged.value,
      district:district.value,
      gps_coordinates:gpsCoordinates.value,
      image: "",
      model:model.value,
      province:province.value,
      sector:sector.value,
      serial_number:serialNumber.value,
      street_house: streetHouse.value,
      tag_number:tagNumber.value,
      uid:uid.value,
      unit_price: unitPrice.value,
      village:village.value
    };

    console.log("update item .....");

    updateInstance
      .put(new ReportingService().UPDATE_ITEM+id, data)
      .then(function (response) {
        
        console.log("response",response.data);

        var objs=transactions.data;
        var index=objs.findIndex((o)=>o.id==id);
        console.log("index",index);
        var obj=response.data.data;
        obj['item_type']=obj.item_category.item_type;
        obj['category_name']=obj.item_category.name;
        obj['out_of_stock_flag']=obj.item_category.out_of_stock_flag;
        obj['supplier_name']=obj.supply.supplier_name;
        obj['damaged']=""+obj['damaged'];
        objs[index]=obj;

        setTransactions({...transactions,open:false,data:objs});
        
        setCell({value:"",error:""});
        setDamaged({value:"",error:""});
        setDistrict({value:"",error:""});
        setGpsCoordinates({value:"",error:""});
        setModel({value:"",error:""});
        setProvince({value:"",error:""})
        setSector({value:"",error:""});
        setSerialNumber({value:"",error:""});
        setStreetHouse({value:"",error:""});
        setTagNumber({value:"",error:""});
        setUid({value:"",error:""});
        setUnitPrice({value:"",error:""});
        setVillage({value:"",error:""});
        
    //   get_supply_items(accountData.token);

        notify("success", response.data.message);

      })
      .catch(function (error) {
        setTransactions({...transactions,open:false});
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });

    }
  }


      /////////////// sale request ///////////////////////

      const [dialogSale,setDialogSale]=useState(false);
      const [loadingSale,setLoadingSale]=useState(false);
      const [customerId,setCustomerId]=useState({value:0,error:""});
      const [itemId,setItemId]=useState({value:0,error:""});
      const [location,setLocation]=useState({value:"",error:""});
      const [paymentAmount,setPaymentAmount]=useState({value:0,error:""});
      const [paymentMethod,setPaymentMethod]=useState({value:"",error:""});
      const [paymentType,setPaymentType]=useState({value:"",error:""});
      const [requestId,setRequestId]=useState({value:0,error:""});
  
      const sale_item=()=>{
        if(customerId.value==0){
          setCustomerId({value:0,error:"No customer presented"});
        }else if(itemId.value==0){
          setItemId({value:0,error:"No item presented"});
        }else if(paymentMethod.value==""){
          setPaymentMethod({value:"",error:"Please select payment method"});
        }else if(paymentAmount.value==0){
          setPaymentAmount({value:0,error:"Please procide correct amount"});
        }else{
          let data={
            "customer_id": customerId.value,
            "item_id": itemId.value,
            "location": location.value,
            "payment_amount": paymentAmount.value,
            "payment_method": paymentMethod.value,
            "payment_type": paymentType.value
            // "request_id": requestId.value,
            // "selling_entity_id": 0
          };
          setLoadingSale(true);
          const saleInstance = axios.create(new AdminService().getHeaders(accountData.token));
          saleInstance
          .post(new ReportingService().SALE_ITEM,data)
          .then(function (response) {
            setLoadingSale(false);
    
            const d = response.data;
  
            console.log("response",d);
            setDialogSale(false);
           
          })
          .catch(function (error) {
  
            setLoadingSale(false);
            var e = error.message;
    
            if (error.response) {
              e = error.response.data.message;
            }
            notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
          });
        }
      }
  
      ////////////// end sale request /////////////////




      ////////////// rent item //////////////////////////


      const [dialogRent,setDialogRent]=useState(false);
      const [loadingRent,setLoadingRent]=useState(false);

      const rent_item=()=>{

        if(customerId.value==0){
          setCustomerId({value:0,error:""});
        }else{
          setLoadingRent(true);
          const rentInstance = axios.create(new AdminService().getHeaders(accountData.token));

         
      
          console.log("rent item  .....");
  
          let data={
            "customer_id": customerId.value,
            "item_id": itemId.value
          }
      
          rentInstance
            .post(new ReportingService().RENT_ITEM,data)
            .then(function (response) {
              setLoadingRent(false);
              console.log("response",response.data);
              // setTransactions({ ...transactions, loading: false });
              const d = response.data;
              notify("success",d.message);
              setDialogRent(false);
              var objs=transactions.data;
              objs=objs.filter((o)=>o.id!=itemId.value);
              setTransactions({...transactions,data:objs});
            })
            .catch(function (error) {
              setLoadingRent(false);
              var e = error.message;
      
              if (error.response) {
                e = error.response.data.message;
              }
      
              notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
            });
        }
 
      }


      /////////////// rent item end ///////////////////
  
      

  return (
    <div className={classes.root}>
      

      {/* start update dialog */}

      <Dialog
        open={transactions.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        fullWidth
        onClose={()=>setTransactions({...transactions,open:false})}
      >
        <DialogTitle id="alert-dialog-title">{"Update Item"}</DialogTitle>
        <DialogContent>
        
          <Box mb={2}>
          <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              type="number"
              value={unitPrice.value}
              placeholder={"Price"}
              label={"Price"}
              fullWidth
              onChange={(e)=>{
                setUnitPrice({value:e.target.value,error:""});
              }}
              helperText={unitPrice.error}
              error={unitPrice.error !== ""}
            />
          </Box>

          <Box mt={2}>

          <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="damaged">Damaged</InputLabel>
        <Select
          labelId="damaged"
          id="damaged_select"
          value={damaged.value}
          onChange={(e)=>{
            if(e.target.value!=""){
              setDamaged({value:e.target.value,error:""});
            }
            
          }}
          label="Age"
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value={"true"}>True</MenuItem>
          <MenuItem value={"false"}>False</MenuItem>
        </Select>
      </FormControl>
            
          </Box>

          <Box mt={2}>
          <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={serialNumber.value}
              placeholder={"Serial Number"}
              label={"Serial Number"}
              fullWidth
              onChange={(e)=>{
                setSerialNumber({value:e.target.value,error:""});
              }}
              helperText={serialNumber.error}
              error={serialNumber.error !== ""}
            />
          </Box>


        <Box mt={2}>
          <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={uid.value}
              placeholder={"UID"}
              label={"UID"}
              fullWidth
              onChange={(e)=>{
                setUid({value:e.target.value,error:""});
              }}
              helperText={uid.error}
              error={uid.error !== ""}
            />
        </Box>


          <Box mt={2}>
            <TextField
                required
                size="small"
                variant="outlined"
                color="primary"
                value={tagNumber.value}
                placeholder={"Tag Number"}
                label={"Tag NUmber"}
                fullWidth
                onChange={(e)=>{
                  setTagNumber({value:e.target.value,error:""});
                }}
                helperText={tagNumber.error}
                error={tagNumber.error !== ""}
              />
          </Box>

          <Box mt={2}>
          <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={model.value}
              placeholder={"Model"}
              label={"Model"}
              fullWidth
              onChange={(e)=>{
                setModel({value:e.target.value,error:""});
              }}
              helperText={model.error}
              error={model.error !== ""}
            />
          </Box>

          <Box mt={2}>
            <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={gpsCoordinates.value}
              placeholder={"GPS Coordinates"}
              label={"GPS Coordinates"}
              fullWidth
              onChange={(e)=>{
                setGpsCoordinates({value:e.target.value,error:""});
              }}
              helperText={gpsCoordinates.error}
              error={gpsCoordinates.error !== ""}
            />
          </Box>

          <Box mt={2}>
            <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={province.value}
              placeholder={"Province"}
              label={"Province"}
              fullWidth
              onChange={(e)=>{
                setProvince({value:e.target.value,error:""});
              }}
              helperText={province.error}
              error={province.error !== ""}
            />
          </Box>

          <Box mt={2}>
            <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={district.value}
              placeholder={"District"}
              label={"District"}
              fullWidth
              onChange={(e)=>{
                setDistrict({value:e.target.value,error:""});
              }}
              helperText={district.error}
              error={district.error !== ""}
            />
          </Box>

          <Box mt={2}>
            <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={sector.value}
              placeholder={"Sector"}
              label={"Sector"}
              fullWidth
              onChange={(e)=>{
                setSector({value:e.target.value,error:""});
              }}
              helperText={sector.error}
              error={sector.error !== ""}
            />
          </Box>


          <Box mt={2}>
            <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={cell.value}
              placeholder={"Cell"}
              label={"Cell"}
              fullWidth
              onChange={(e)=>{
                setCell({value:e.target.value,error:""});
              }}
              helperText={cell.error}
              error={cell.error !== ""}
            />
          </Box>
          <Box mt={2}>
            <TextField
              required
              size="small"
              variant="outlined"
              color="primary"
              value={village.value}
              placeholder={"Village"}
              label={"Village"}
              fullWidth
              onChange={(e)=>{
                setVillage({value:e.target.value,error:""});
              }}
              helperText={village.error}
              error={village.error !== ""}
            />
          </Box>
      


         

        </DialogContent>
        <DialogActions>
          <Button 
           variant='outlined'
          onClick={() => {
            setTransactions({...transactions,open:false})
          }} color="primary">
            Cancel
          </Button>
          <Button 
          variant='contained'
          disableElevation
          disabled={transactions.loading}
          onClick={() => {
            updateItem();
          }} color="primary" autoFocus>
            {transactions.loading ? <CircularProgress size={23} /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* end update dialog */}


{/* ////////////////////////    sale dialog ////////////////////////// */}

<Dialog
        open={dialogSale}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        fullWidth
        onClose={()=>setDialogSale(false)}
      >
        <DialogTitle id="alert-dialog-title">Sale Item</DialogTitle>
        <DialogContent>
        <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={paymentAmount.value}
                  placeholder={"Payment Amount"}
                  label={"Payment Amount"}
                  fullWidth
                  onChange={(e)=>{
                    setPaymentAmount({value:e.target.value,error:""});
                  }}
                  helperText={paymentAmount.error}
                  error={paymentAmount.error !== ""}
                />
          </Box>
          <Box mt={2}>
          <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={location.value}
                  placeholder={"Location"}
                  label={"Location"}
                  fullWidth
                  onChange={(e)=>{
                    setLocation({value:e.target.value,error:""});
                  }}
                  helperText={location.error}
                  error={location.error !== ""}
                />
          </Box>

          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={paymentType.error!=""}
            >
              <InputLabel>
                <Typography>Payment Type</Typography>
              </InputLabel>
              <Select
                label={"Payment Type"}
                value={paymentType.value}
                onChange={(e)=>{
                  setPaymentType({value:e.target.value,error:""});
                }}
              >
                {["DIRECT","LOAN"]?.map((tp, i) => (
                  <MenuItem value={tp}>{tp}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {paymentType.error}
              </FormHelperText>
            </FormControl>
          </Box>

          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={paymentMethod.error!=""}
            >
              <InputLabel>
                <Typography>Payment Method</Typography>
              </InputLabel>
              <Select
                label={"Payment Type"}
                value={paymentMethod.value}
                onChange={(e)=>{
                  setPaymentMethod({value:e.target.value,error:""});
                }}
              >
                {["CASH","MTN_MOBILE_MONEY","AIRTEL_MONEY","CARD","BANK_TRANSFER","BOOKING","PROMOTION"]?.map((tp, i) => (
                  <MenuItem value={tp}>{tp}</MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {paymentMethod.error}
              </FormHelperText>
            </FormControl>
          </Box>

          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={customerId.error!=""}
            >
              <InputLabel>
                <Typography>Select Customer</Typography>
              </InputLabel>
              <Select
                label={"Select Customer"}
                value={customerId.value}
                onChange={(e)=>{
                  setCustomerId({value:e.target.value,error:""});
                }}
              >
                {customers?.map((tp, i) => (
                  <MenuItem value={tp.id}>{tp.full_names}</MenuItem>
                ))}

              </Select>
              <FormHelperText>
                {customerId.error}
              </FormHelperText>
            </FormControl>
          </Box>

        </DialogContent>
        <DialogActions>
          <Button 
           variant='outlined'
          onClick={() => {
            setDialogSale(false);
          }} color="primary">
            Cancel
          </Button>
          <Button 
          variant='contained'
          disableElevation
          disabled={loadingSale}s
          onClick={() => {
            sale_item();
          }} color="primary" autoFocus>
            {loadingSale? <CircularProgress size={23} /> : "Save"}
          </Button>
         
        </DialogActions>
      </Dialog>

{/* ///////////////////////////  end sale dialog //////////////////////////// */}



{/* ////////////////////////    rent item dialog ////////////////////////// */}

<Dialog
        open={dialogRent}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='sm'
        fullWidth
        onClose={()=>setDialogRent(false)}
      >
        <DialogTitle id="alert-dialog-title">Sale Item</DialogTitle>
        <DialogContent>
       
          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={customerId.error!=""}
            >
              <InputLabel>
                <Typography>Select Customer</Typography>
              </InputLabel>
              <Select
                label={"Select Customer"}
                value={customerId.value}
                onChange={(e)=>{
                  setCustomerId({value:e.target.value,error:""});
                }}
              >
                {customers?.map((tp, i) => (
                  <MenuItem value={tp.id}>{tp.full_names}</MenuItem>
                ))}

              </Select>
              <FormHelperText>
                {customerId.error}
              </FormHelperText>
            </FormControl>
          </Box>

        </DialogContent>
        <DialogActions>
          <Button 
           variant='outlined'
          onClick={() => {
            setDialogRent(false);
          }} color="primary">
            Cancel
          </Button>
          <Button 
          variant='contained'
          disableElevation
          disabled={loadingRent}
          onClick={() => {
            rent_item();
          }} color="primary" autoFocus>
            {loadingRent? <CircularProgress size={23} /> : "Rent"}
          </Button>
        </DialogActions>
      </Dialog>

{/* ///////////////////////////  end rent item dialog //////////////////////////// */}

      <Box mt={2} />
      <Grid container spacing={2}>
        {transactions?.keys?.map((tr, i) => (
          <Grid item xs={12} sm={4} lg={3}>
            <Paper elevation={0} className={classes.paper}>
              <Box width={1}>
                <Box display="flex" width={1}>
                  <Box flexGrow={1}>
                    <Typography>{tr}</Typography>
                    <Typography color="textSecondary">
                      {transactions?.groups[tr][0].category_name}
                    </Typography>
                  </Box>
                  {tr[0].item_type == "CARD" ? (
                    <CreditCard color="primary" fontSize="large" />
                  ) : (
                    <DevicesOther color="primary" fontSize="large" />
                  )}
                </Box>
                <Box
                  mt={1}
                  mb="4px"
                  display="flex"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  width={1}
                >
                  <Tooltip
                    title={transactions?.groups[tr].length}
                    arrow
                    placement="top"
                  >
                    <Typography variant="h5">
                      {transactions?.groups[tr].length}
                    </Typography>
                  </Tooltip>
                  {/* {new Validator().sum(
                    transactions?.groups[tr],
                    "damaged"
                  ) != 0 && (
                    <Typography color="error" align="right">
                      {new Validator().sum(
                        transactions?.groups[tr],
                        "damaged"
                      )}
                      {" NoK"}
                    </Typography>
                  )} */}
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Box mt={2} />
      {transactions.loading && <LinearProgress />}
      <MUIDataTable
        title={"Stock Items"}
        data={transactions.data}
        columns={transactionsColums}
        options={transactionsOptions}
      />
    </div>
  );
}

function CustomItemToolbar(props) {
  const {displayData, selectedRows,getItem,setItemId,setDialogSale,setDialogRent} = props;

 
  return (
    <Box display="flex" alignItems="center">
     

      <Box>
      <Button
        color="primary"
        variant="outlined"
        size="small"
        startIcon={<Edit />}
        onClick={() =>{
          getItem(displayData[selectedRows?.data[0]?.index].data[0]);
          console.log("edit",displayData[selectedRows?.data[0]?.index].data[0])
        }
        }
      >
        Edit
      </Button>
      </Box>
      <Box ml={2}>
      <Button
        color="primary"
        variant="outlined"
        size="small"
        startIcon={<AttachMoney />}
        onClick={() =>{
          console.log("edit",displayData[selectedRows?.data[0]?.index].data[0])
          setItemId({value:displayData[selectedRows?.data[0]?.index].data[0],error:""});
          setDialogSale(true);
        }
        }
      >
        Sale
      </Button> 
      </Box>

      <Box ml={2}>
      <Button
        color="primary"
        variant="outlined"
        size="small"
        startIcon={<AvTimer />}
        onClick={() =>{
          console.log("edit",displayData[selectedRows?.data[0]?.index].data[0])
          setItemId({value:displayData[selectedRows?.data[0]?.index].data[0],error:""});
          setDialogRent(true);
        }
        }
      >
        Rent
      </Button>
      </Box>    

    </Box>
  );
}

export default withLocalize(StockStatusTwo);
